import React, { FC, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Button from "../../Button/Button";
import TextInput from "../../TextInput/TextInput";
import useUser from "../../../hooks/useUser";

import styles from "./styles.module.scss";

interface ForgotPasswordFormValues {
  email: string;
}

const ForgotPasswordForm: FC = () => {
  const [reseted, setReseted] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<ForgotPasswordFormValues>({
    mode: "onChange",
  });

  const { onForgotPassword } = useUser();

  const isSubmitButtonDisabled = Object.keys(errors).length > 0;

  return (
    <>
      {reseted ? (
        <>
          <p>
            If an account exists for <span>example@example.com</span>, we’ll
            send an email with instructions on reseting your password.
          </p>
          <p>If you don’t get the email, please check your spam folder.</p>

          <Button className={styles.okay} type="button" mode="text">
            Okay
          </Button>
        </>
      ) : (
        <form
          className={styles.form}
          onSubmit={handleSubmit((data) => {
            if (Object.keys(errors).length !== 0) return null;

            new Promise((resolve, reject) => {
              onForgotPassword({ email: data.email, redirect_url: "https://accounts.boomform.com" });
            }).then(() => {
              setReseted(true);
            });
          })}
        >
          <Controller
            name="email"
            control={control}
            rules={{
              required: "This field is required.",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "That’s an invalid e-mail",
              },
            }}
            render={({ field }) => (
              <TextInput
                label="Email"
                placeholder="example@example.com"
                error={errors.email && errors.email.message}
                onChange={(event) => field.onChange(event.target.value)}
              />
            )}
          />

          <Button
            className={styles.reset}
            disabled={isSubmitButtonDisabled}
            type="submit"
            mode={"filled"}
          >
            Reset
          </Button>
        </form>
      )}
    </>
  );
};

export default ForgotPasswordForm;
